import React, { useMemo } from 'react'
import { ClientBasicInfoContainer } from '../index.styled'
import IogoIcon from '../../../asserts/icon/ic_dlc_logo.svg'
import Bg_01 from '../../../asserts/images/physical-assessment/bg_top_01.png'
import Bg_02 from '../../../asserts/images/physical-assessment/bg_top_02.png'
import moment from 'moment'
import TextEditior from '../../../components/TextEditior'
import GenericPdfDownloader from '../../../components/assessmentReview/comp/GenericPdfDownloader'
import { PAGE_ID } from '..'
import { find, get } from 'lodash'

const Fields = {
  CLIENT: 'client',
  SESSION: 'session',
  ASSESSMENT_DATE: 'assessment_date',
  LOCATION: 'location',
  ASSESSMENT_LEAD: 'recommendation_assessment_lead'
}

const { CLIENT, SESSION, ASSESSMENT_DATE, LOCATION, ASSESSMENT_LEAD } = Fields

const SESSION_VALUE = 'Assessment Review'

const Row = ({ field, label, placeholder, editabled, data, onChange }) => {
  const value = useMemo(() => {
    const _value = data[field]
    if (field === ASSESSMENT_DATE) return moment(_value).format('MMM D, yyyy')
    return _value
  }, [field, data])

  return (
    <div className="item">
      <div className="label">{label}:</div>
      {editabled ? (
        <TextEditior
          value={value}
          required={true}
          placeholder={placeholder}
          onChange={(v) => onChange(v, field)}
        />
      ) : (
        <div className="value">{value}</div>
      )}
    </div>
  )
}

export default function ClientBasicInfoSection({
  editabled,
  person,
  arDetail,
  onUpdateNotes
}) {
  const { created_at, notes } = arDetail
  const { full_name, facility } = person
  const assessmentLead = find(notes, { pillar: ASSESSMENT_LEAD })
  const data = {
    [CLIENT]: full_name,
    [SESSION]: SESSION_VALUE,
    [ASSESSMENT_DATE]: created_at,
    [LOCATION]: facility ? facility.address : '-',
    [ASSESSMENT_LEAD]: assessmentLead ? assessmentLead.memo : ''
  }

  const queryParams = new URLSearchParams(window.location.search)
  const uploadRequest = queryParams.get('savePDF') === 'true'

  const InfoConfigs = useMemo(
    () => [
      {
        field: CLIENT,
        label: 'Client'
      },
      {
        field: SESSION,
        label: 'Session'
      },
      {
        field: ASSESSMENT_DATE,
        label: 'Assessment Date'
      },
      {
        field: LOCATION,
        label: 'Location'
      },
      {
        field: ASSESSMENT_LEAD,
        label: 'Assessment Lead',
        placeholder: 'Please enter assessment lead',
        editabled
      }
    ],
    [editabled]
  )

  return (
    <ClientBasicInfoContainer>
      <div className="header">
        <img src={get(person, 'facility.logo.oss_url', IogoIcon)} alt="Logo" />
        {/* <Button className='save-btn' disabled={saving}>
          SAVE AS PDF
        </Button> */}
        <GenericPdfDownloader
          uploadRequest={uploadRequest}
          ids={PAGE_ID}
          className="download-pdf"
          person={person}
          filename={`${(person.profile && person.profile.nickname) ||
            person.first_name}-report.pdf`}
        />
      </div>
      <div className="title">Achieve the Best Possible Version of You</div>
      <div className="info-section">
        {InfoConfigs.map((item, index) => (
          <Row key={index} {...item} data={data} onChange={onUpdateNotes} />
        ))}
      </div>
      <div className="tips">
        CONFIDENTIAL AND PROPRIETARY - FOR CLIENT’S PERSONAL USE ONLY
      </div>
      <div className="bg-section">
        <img className="bg-1" src={Bg_01} alt="bg" />
        <img className="bg-2" src={Bg_02} alt="bg" />
      </div>
    </ClientBasicInfoContainer>
  )
}
